require('./leaveModal.scss');

// @vendor
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

//@commons
const OKModal = require('components/commons/OKModal/OKModal');

// @ assets
const leaveModalIcon = require('../../assets/penguin-one-holder.svg');

// @ helpers
const { formatText } = require('core/i18n').i18n;
import { recordLinkV2 } from 'utilities/tagging';

// @ constants
import { migrationLeaveModalKeys } from './leaveModal.poeditor';
import { analyticsId, catalogue } from './analytics/leaveModal.tracking';
import { MODAL_TYPE } from '../../migrationUsersBranchView.constants';

export const LeaveModal = ({
  handleCancel,
  handleContinue,
  handleOnClose,
  modalType,
  showModal,
}) => {
  const history = useHistory();
  const immScreen = useSelector(state => state.screen);

  const overlayClassName = 'leave-modal__overlay';
  const overlayDefaultClassName = 'leave-modal__overlay-default';

  const description = formatText(migrationLeaveModalKeys.description);
  const content = (
    <>
      <div className="leave-modal__content-icon">
        <img className="leave-modal__content-icon__img" src={leaveModalIcon} />
      </div>
      <div className="leave-modal__description">{description}</div>
    </>
  );
  if (!showModal) {
    return null;
  }
  if (modalType === MODAL_TYPE.NOT_MIGRATE) {
    return (
      <OKModal
        content={content}
        isOpen={showModal}
        onCloseCallback={() => {
          recordLinkV2(catalogue[analyticsId.CLOSE_MODAL]());
          handleOnClose();
        }}
        size="large"
        title={formatText(migrationLeaveModalKeys.title)}
        footerType="navigation"
        onPrimaryButtonClick={() => {
          recordLinkV2(catalogue[analyticsId.CONTINUE_BUTTON]());
          handleContinue();
        }}
        onSecondaryButtonClick={() => {
          recordLinkV2(catalogue[analyticsId.CANCEL_LINK]());
          handleCancel();
        }}
        overlayClassName={overlayClassName}
        primaryButtonText={<strong>{formatText(migrationLeaveModalKeys.continueButton)}</strong>}
        secondaryButtonText={<strong>{formatText(migrationLeaveModalKeys.cancelLink)}</strong>}
        analyticsDataView={catalogue[analyticsId.DISPLAY_MODAL]()}
      />
    );
  }

  return (
    <OKModal
      description={migrationLeaveModalKeys.descriptionLeave}
      descriptionAlignment="center"
      footerType="action"
      isOpen={showModal}
      onCloseCallback={() => {
        recordLinkV2(catalogue[analyticsId.CLOSE_LEAVE_MODAL]());
        handleOnClose();
      }}
      onPrimaryButtonClick={() => {
        recordLinkV2(catalogue[analyticsId.RIGHT_LEAVE_BUTTON]());
        if (immScreen.get('desktop')) {
          history.push('/myprofile/global');
        } else {
          window.location.href = '/myprofile/global/';
        }
      }}
      onSecondaryButtonClick={() => {
        recordLinkV2(catalogue[analyticsId.LEFT_LEAVE_LINK]());
        handleOnClose();
      }}
      primaryButtonText={migrationLeaveModalKeys.buttonRightLeave}
      secondaryButtonText={migrationLeaveModalKeys.buttonLeftLeave}
      shouldCloseOnOverlayClick={false}
      title={migrationLeaveModalKeys.titleLeave}
      titleAlignment="center"
      overlayClassName={overlayDefaultClassName}
      analyticsDataView={catalogue[analyticsId.DISPLAY_LEAVE_MODAL]()}
    />
  );
};

LeaveModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  migrationState: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
};
